import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { TemplateDto } from "@/core/features/templates/template.dto";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { CreateTemplateDto } from "@/core/features/templates/create-template.dto";
import { UpdateTemplateDto } from "@/core/features/templates/update-template.dto";

export class TemplatesResource extends ResourceBaseService<TemplateDto, CreateTemplateDto, UpdateTemplateDto> {
  protected EntityDto = TemplateDto;
  protected CreateEntityDto = CreateTemplateDto;
  protected UpdateEntityDto = UpdateTemplateDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/templates");
  }
}
